/**
 * lib/brand barrel export
 * Identidade Visual eBuz v1.0
 */

export { BRAND_TOKENS, EBUZ_DEFAULT_THEME, BRAND_VOICE } from './tokens'
export type { EbuzTheme } from './tokens'

export { PlusMotif, GridBg, GradientText } from './motifs'

export { alpha, contrastRatio, passesAA } from './colors'
